import { createRouter, createWebHistory,createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../views/Index.vue'),
    children: [
      {
        path: '/',
        name: '',
        component: () => import('../views/Home/Home.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/About/index.vue'),
      },
      {
        path: '/buiness',
        name: 'buiness',
        component: () => import('../views/buiness/index.vue'),
      },
      {
        path: '/new',
        name: 'new',
        component: () => import('../views/New/New.vue'),
      },
      {
        path: '/product',
        name: '产品中心',
        component: () => import('../views/product/index.vue'),
      },

      {
        path: '/videooman',
        name: '视频合集',
        component: () => import('../views/videooman/index.vue'),
      },

      {
        path: '/buinessadv',
        name: '企业优势',
        component: () => import('../views/buinessadv/index.vue'),
      },
      {
        path: '/apply',
        name: '申请合作',
        component: () => import('../views/apply/index.vue'),
      },
      {
        path: '/study',
        name: '发酵研究',
        component: () => import('../views/study/index.vue'),
      },
      {
        path: '/rongyu',
        name: '荣誉资质',
        component: () => import('../views/rongyu/index.vue'),
      },
      {
        path: '/culture',
        name: '企业文化',
        component: () => import('../views/culture/index.vue'),
      },
    ]
  },

]


const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
export default router
